import { showTrxTransactionPopup } from '@/core/presenter/controller/PopupController';
import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  trxTransaction: ViewModel.IResponseActivity;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TrxTransactionItem = ({ trxTransaction }: IProps) => {
  const handleClickTrxTransactionItem = useCallback(() => {
    showTrxTransactionPopup(trxTransaction);
  }, [trxTransaction]);

  const handleCopyClick = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
    // 이벤트 전파 방지
    e.stopPropagation();

    const text = trxTransaction.type === '보내기' ? trxTransaction.to : trxTransaction.from;
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <li data-type={trxTransaction.type} onClick={handleClickTrxTransactionItem}>
        <a href="#">
          <div className="date">{trxTransaction.date}</div>
          <div className="row">
            <div className="left">
              <div className="icotxt">
                <div className="icon-area">
                  <img
                    src={`img/con-${trxTransaction.imgType.toLowerCase()}-icon.png`}
                    alt={`${trxTransaction.imgType}-icon`}
                  />
                </div>
                <p className="mn-gray i-txt">{trxTransaction.coinType}</p>
              </div>
              <div className="txt-box">
                <div className="top">
                  <div className="sendOrReceiveAndButton-wrap">
                    <p className="body-l">{trxTransaction.type}</p>
                    <div
                      className={clsx('bottom status', {
                        success: trxTransaction.status === '성공',
                        fail: trxTransaction.status === '실패',
                      })}
                    >
                      {trxTransaction.status}
                    </div>
                  </div>
                  <div className="linkAndMemo">
                    <div className="destination">
                      <i
                        className={clsx(
                          'bi',
                          {
                            'bi-arrow-right-short': trxTransaction.type === '보내기',
                            'bi-arrow-left-short': trxTransaction.type === '받기',
                          },
                          'body-xl ml-gray',
                        )}
                      ></i>
                      <p className="body-n" onClick={handleCopyClick}>
                        {trxTransaction.type === '보내기' ? trxTransaction.to_short : trxTransaction.from_short}
                      </p>
                      <i className="bi bi-files" onClick={handleCopyClick}></i>
                    </div>
                    <span className="activity-memo body-s-n">
                      {trxTransaction.type === '보내기' ? trxTransaction.to_memo : trxTransaction.from_memo}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="right">
              <div className="top">
                <p className="body-xl">{trxTransaction.amount}</p>
                <span className="ml-gray i-txt">{trxTransaction.krwAmount}</span>
              </div>
            </div>
          </div>
        </a>
      </li>
    </>
  );
};

export default TrxTransactionItem;
